<div class="customize-fields__inner-container">
  @if (customizeFieldBool.field?.fieldTypeId === 'boolp') {
    <div class="customize-fields__container-two-elements">
      <field-type-number class="customize-fields__inner-two-container"
        [field]="customizeFieldBool.weightYesInfo"
        [preSelectItem]="customizeFieldBool.field.weightYes"
        (itemSelected)="itemSelected($event, 'weightYes')">
      </field-type-number>
      <field-type-number class="customize-fields__inner-two-container"
        [field]="customizeFieldBool.weightNoInfo"
        [preSelectItem]="customizeFieldBool.field.weightNo"
        (itemSelected)="itemSelected($event, 'weightNo')">
      </field-type-number>
    </div>
  }
  <field-type-switch
    [field]="customizeFieldBool.codeColor"
    [small]="true"
    [preSelectItem]="customizeFieldBool.field.color"
    [disabled]="concept.disabled || previewMode"
    (itemSelected)="itemSelected($event, 'color')">
  </field-type-switch>
  @if(customizeFieldBool.field?.color){
    <div class="common-text-input__container">
      <div class="common-text-input__container-box-configure-color"
        [attr.disabled]="concept.disabled || previewMode?true:null">
        <div class="customize-fields__inner-code-color">
          <button class="common-button__decision-button" disabled>
              <span class="common-button__decision-button-label-text"
                [afTranslate]="'common.yes'">_Si</span>
          </button>
          <div class="common-badge__block-dot-md">
            <div [ngClass]="customizeFieldBool.field.withColor === 1?'common-badge__dot-md-green':'common-badge__dot-md-red'"></div>
          </div>
        </div>
        <button class="common-button__icon-sm-noborder"
            (click)="itemSelected($event, 'withColor')"
            [disabled]="concept.disabled || previewMode">
            <i class="lf-icon-arrow-exchange common-icon__md"></i>
        </button>
        <div class="customize-fields__inner-code-color">
          <button class="common-button__decision-button" disabled>
              <span class="common-button__decision-button-label-text"
                [afTranslate]="'common.no'">_No</span>
          </button>
          <div class="common-badge__block-dot-md">
            <div [ngClass]="customizeFieldBool.field.withColor === 1?'common-badge__dot-md-red':'common-badge__dot-md-green'"></div>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="customize-fields-switch-form__container">
    <customize-fields-switch-form
      [field]="customizeFieldBool.field"
      [small]="true"
      [concept]="concept"
      [isPrivate]="isPrivate"
      [hiddenInLandings]="hiddenInLandings"
      [previewMode]="previewMode"></customize-fields-switch-form>
  </div>
</div>
